<template>
  <div>
    <!--pc端-->
    <nav-header
      v-bind:showSearch="p_showSearch"
      v-bind:loginModalFlag="p_loginModalFlag"
      v-on:showLoginModal="p_showLoginModal"
      v-on:closeLoginModal="p_closeLoginModal"></nav-header>
    <div>
      <router-view></router-view>
    </div>
    <!--底部导航-->
    <tabbar class="mobile" :selected="selected" :tabs='tabs'></tabbar>
  </div>

</template>

<script>

  import '../../assets/css/base.css'
  import '@/assets/css/product.css'

  // import axios from 'axios'
  import Tabbar from '@/components/Tabbar.vue'
  import NavHeader from '@/components/Header.vue'
  import NavFooter from '@/components/Footer.vue'
  import NavBread from '@/components/Bread.vue'

  export default {
    data() {
      return {
        p_showSearch:true,
        p_loginModalFlag:false,
        selected: '',
        tabs: [
          require("@/assets/hose_Filled.png"),
          require("@/assets/shopping_grey.png"),
          require("@/assets/me_grey.png")
        ]
      }
    },
    components: {
      Tabbar,
      NavHeader,
      NavFooter,
      NavBread,
    },
    methods: {
      p_showLoginModal(){
        this.p_loginModalFlag = true
      },
      p_closeLoginModal(){
        this.p_loginModalFlag = false
      },

    },
    mounted: function () {

    }
  }
</script>

<style scoped>
  .mobile{
    display: none;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .mobile{
      display: block;
    }
    .binBan {
      margin-top: 40px;
    }
   /deep/ .banPic{
      height: 235px!important;
      margin-top: 30px;
    }
    /deep/ .conBan{width: 95%!important;}
    /deep/ .comCon {
      width: 97%;
      margin-top: 17px;
      margin-bottom: 20px;
    }
    /deep/ .comLogo {
      margin-top: 22px;
      margin-left: 110px;
    }
    /deep/ .comMain{
      width: 90.66%!important;
      margin: 0 auto;
      margin-top: 30px;
    }
    /deep/ .accessory-list .main .name {
      min-height: 34px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/company/Company.vue